// extracted by mini-css-extract-plugin
export default {"openCategory":"RegularCategory_openCategory__5cjt-"};